import dataProvider from "data/hasura";
import { AccessControlProvider } from "@refinedev/core";
import { checkAttributes, checkGrant } from "./rabac";
import { getDomainRole } from "@utils/site";
import { authProvider } from "auth/firebase";
import { IAuthUser } from "@auth/firebase/interfaces";
import { PRO_ROLES, Role, USER_ROLES } from "./definitions";
import { grantListRABAC } from "./rabacDefs";
import { roleAtom } from "../auth/firebase/state";
import { getDefaultStore } from "jotai";
import { logger } from "@utils/logger";

const getSubscription = async (role: Role) => {
  /**
   * Validate subscription
   * The subscription is called "plan" in case of "user" roles
   * The subscription is called "membership" in case of "pro" roles
   */
  const identity = await authProvider.getIdentity?.() as IAuthUser
  if (USER_ROLES.includes(role)) {
    const { data } = await dataProvider.getOne({
      resource: "auth_users",
      id: identity?.user_id,
      meta: {
        fields: [
          { 'service_user': [{ 'plan': ['name'] }] }
        ],
      }
    })
    return data?.service_user?.plan?.name
  } else if (PRO_ROLES.includes(role)) {
    const { data } = await dataProvider.getOne({
      resource: "auth_users",
      id: identity?.user_id,
      meta: {
        fields: [
          { 'professional': [{ 'membership': ['name'] }] }
        ],
      }
    })
    return data?.professional?.membership?.name
  }
}

export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, action, params }) => {
    //logger.debug("rbac", { resource, action, params }); // products, orders, etc.
    //logger.debug("action", action); // list, edit, delete, etc.
    //logger.debug("params", params); // { id: 1 }, { id: 2 }, etc.

    let role = getDefaultStore().get(roleAtom).role
    //logger.debug("accessControlProvider role: ", role);
    console.log("accessControlProvider role: ", role);

    const attributes = params!.attributes

    const { role: domainHostRole, host } = getDomainRole(role)
    //logger.debug("domainHostRole", domain)

    role = params!.domainRoleEnable ? domainHostRole : role
    //logger.debug("domainRoleEnable role: ", role);

    // check if 'domain' option in params includes the current domain, and allow access immediately
    if (params!.domain) {
      logger.debug("domain role", { host, role, domainHostRole, domain: params!.domain })
      if (params!.domain == domainHostRole) {
        return { can: true };
      } else {
        return {
          can: false,
          reason: "Unauthorized domain",
        };
      }
    }

    // check if 'roles' option in params includes the current role, and allow access immediately
    if (params?.roles) {
      logger.debug("roles", { roles: params?.roles, role })
      if (params.roles.includes(role)) {
        return { can: true };
      } else {
        return {
          can: false,
          reason: "Unauthorized roles",
        };
      }
    }

    /*****
    * Permission matrix
    ******/
    // debugging resources
    if (resource == 'debugging' && host == 'localhost') {
      return { can: true };
    }

    // validate subscriptions
    if (params?.validateSubscription) {
      // Saltar validación de user_band0
      if (role === 'user_band0') {
        return { can: true };
      }
      
      const subscription = await getSubscription(role)
      logger.debug("subscription: ", subscription);

      if (!subscription) {
        return { can: false, reason: 'No choosen subscription' };
      }
    }

    // all other RABAC logic

    const grantResource = !resource ? '' : resource
    logger.debug("check grant", { role, resource, action })
    const out = checkGrant(grantListRABAC, { role, resource: grantResource, action })
    if (out.granted && checkAttributes(out.attributes, attributes)) {
      return { can: true }
    }

    return {
      can: false,
      reason: "Unauthorized",
    };
  },
};
